import { render, staticRenderFns } from "./Timecard.vue?vue&type=template&id=0a059e89&scoped=true&"
import script from "./Timecard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Timecard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Timecard.vue?vue&type=style&index=0&id=0a059e89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a059e89",
  null
  
)

export default component.exports